export default "__VITE_ASSET__Dh_XYEOI__"